<template>
  <div class="login-form">
    <div class="login-form-content">
      <form id="login-form" :class="{ active: panel === 'login' }" class="login-form-login-section">
        <div class="close-button">
          <a class="icon-close" @click.prevent="onExit" />
        </div>
        <h1 class="heading heading__sm"><span class="orange-line">Log in</span> to your account</h1>
        <div class="input-wrapper">
          <input
            id="username"
            v-model.trim="loginUsername"
            class="form-control"
            data-validation="required"
            type="text"
          />
          <label class="form-label" for="username"> Email </label>
        </div>
        <div class="input-wrapper">
          <input
            id="password"
            v-model.trim="loginPassword"
            class="form-control"
            data-validation="required"
            type="password"
          />
          <label class="form-label" for="password"> Password </label>
        </div>

        <ButtonArrow class="btn-yellow btn-login" type="submit"> Login</ButtonArrow>
        <router-link :to="{ path: '/register' }" @click.native="onExit">
          <ButtonArrow class="btn-white btn-register" type="submit"> Create new account</ButtonArrow>
        </router-link>
        <a id="#retrieve-password" class="link-orange" href="#" @click.prevent="switchPanel"> Forgot password? </a>
      </form>

      <form id="retrieve-password-form" :class="{ active: panel === 'retrieve' }" class="login-form-forgotten-section">
        <div class="close-button">
          <a class="icon-close" @click.prevent="onExit" />
        </div>
        <h2 class="heading heading__sm"><span class="orange-line">Retrieve</span> your password</h2>

        <label class="form-label" for="email"> Enter your e-mail address to retrieve your password </label>
        <input id="email" v-model.trim="retrieve.email" class="form-control" data-validation="email" type="text" />
        <ButtonArrow class="btn-yellow" type="submit"> Retrieve Password</ButtonArrow>
        <a id="#back-to-login" class="link-orange" href="#" @click.prevent="switchPanel"> Back to Login </a>
      </form>
    </div>

    <div class="login-form-image listener">
      <div class="close-button">
        <a class="icon-close" @click.prevent="onExit" />
      </div>
    </div>
  </div>
</template>

<script>
import auth from '../../../auth'
import ButtonArrow from '../button-arrow/ButtonArrow'

export default {
  name: 'LoginForm',
  components: {
    ButtonArrow,
  },
  props: {
    lt: {
      type: String,
      default: 'listener',
    },
    onExit: {
      type: Function,
      default: () => {},
    },
    onPasswordRetrieval: {
      type: Function,
      default: () => {},
    },
    onSuccess: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      panel: 'login',
      login: {
        username: '',
        password: '',
        type: this.lt,
      },
      loginUsername: '',
      loginPassword: '',
      retrieve: {
        email: '',
      },
    }
  },
  watch: {
    loginPassword: function (newVal) {
      if (newVal.length > 0) {
        document.getElementById('password').classList.add('has-value')
      } else {
        document.getElementById('password').classList.remove('has-value')
      }
      this.login.password = newVal
    },
    loginUsername: function (newVal) {
      if (newVal.length > 0) {
        document.getElementById('username').classList.add('has-value')
      } else {
        document.getElementById('username').classList.remove('has-value')
      }
      this.login.username = newVal
    },
  },
  mounted: function () {
    $('#loginModal').on('hidden.bs.modal', () => {
      this.panel = 'login'
    })

    const self = this
    $.validate({
      form: '#login-form',
      modules: 'html5',
      validateOnBlur: false,
      validateHiddenInputs: true,
      scrollToTopOnError: true,
      onSuccess: function () {
        self.checkLogin()
        return false
      },
    })

    $.validate({
      form: '#retrieve-password-form',
      modules: 'html5',
      validateOnBlur: false,
      validateHiddenInputs: true,
      scrollToTopOnError: true,
      onSuccess: function () {
        self.retrievePassword()
        return false
      },
    })
  },
  methods: {
    checkLogin: function () {
      const credentials = {
        username: this.login.username,
        password: this.login.password,
        type: 'podcaster',
      }

      auth.login(this, credentials)

      this.onSuccess()
    },
    retrievePassword: function () {
      const credentials = {
        email: this.retrieve.email,
      }

      auth.retrievePassword(this, credentials)
      this.retrieve = {
        email: '',
      }

      this.onPasswordRetrieval()
    },
    switchPanel: function () {
      this.panel = this.panel === 'login' ? 'retrieve' : 'login'
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/reused-components/login-form/LoginForm.vue